import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RsvpDto } from '../types/RsvpDto';

const DEFAULT_OPTIONS = {
  headers: new HttpHeaders({
    accept: '*/*',
  }),
} satisfies any;

@Injectable({
  providedIn: 'root',
})
export class RsvpEventService {
  private _options = DEFAULT_OPTIONS;

  private _isPostInProgress$ = new BehaviorSubject(false);
  /**
   * Global observable for tracking whether the client
   * is awaiting a fetch call for 'postRsvpFromDisplay'.
   */
  public isPostInProgress$ = this._isPostInProgress$.asObservable();

  constructor(private http: HttpClient) {}

  postReservationFromDisplay(
    meetingGuid: string | null,
    stakeGuid: string | null,
    totalAttendees: number | null
  ): Observable<any> {
    if (!stakeGuid || !meetingGuid || !totalAttendees) {
      return of(undefined).pipe(
        tap(() => this._isPostInProgress$.next(true)),
        delay(2000),
        tap({
          error: (error) => {
            console.error('Error get attachment by guid:', error);
          },
          complete: () => {
            this._isPostInProgress$.next(false);
          },
        })
      );
    }

    const body: RsvpDto = {
      MeetingGuid: meetingGuid,
      StakeGuid: stakeGuid,
      TotalAttendees: totalAttendees,
    };
    return this.http.post<any>(`${environment.ApiUrl}/RSVP/`, body, this._options).pipe(
      tap(() => this._isPostInProgress$.next(true)),
      tap({
        error: (error) => {
          console.error('Error get attachment by guid:', error);
        },
        complete: () => {
          this._isPostInProgress$.next(false);
        },
      })
    );
  }
}
